import { KulionerReceiptSectionProps } from "../types";
import { colors, margin } from "../constants";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import { limitLengthName } from "@/app/ui/modules/receipt-v2/module";

export const renderMerchantRecipient = ({
  doc,
  x,
  y,
  pageWidth,
  data
}: KulionerReceiptSectionProps): number => {
  y += 12.5;
  const widthColumn = pageWidth / 2 - margin.right * 1.5;
  const startYBorder = y + 1.5;
  const recipientX = x + widthColumn + margin.right;

  const renderBox = (title: string, xPos: number) => {
    const isMerchant = title.toLowerCase() === "merchant";

    doc.setTextColor(colors.primary);
    doc.setFont("helvetica", "bold");
    doc.text(title, xPos, y);
    doc.setDrawColor(colors.border);
    doc.roundedRect(xPos, startYBorder, widthColumn, 14, 1, 1, "S");

    let yPos = y + 5;
    doc.setFont("helvetica", "bold");
    doc.text(
      isMerchant
        ? ellipsisString(data.koMerchantName, 30)
        : limitLengthName(data.koRecipientName, 30),
      xPos + 2,
      yPos
    );
    yPos += 3;
    doc.setFont("helvetica", "normal");
    doc.text(
      isMerchant
        ? data.koMerchantPhoneNumber
        : data.koRecipientPhoneNumber.replace(/(\d{4})$/, "****"),
      xPos + 2,
      yPos
    );
    yPos += 3;
    doc.setTextColor(colors.secondary);
    const splitAddress = doc.splitTextToSize(
      ellipsisString(
        isMerchant ? data.koMerchantAddress : data.koRecipientAddress,
        70
      ),
      widthColumn - 4 // padding left and right
    );
    doc.text(splitAddress, xPos + 2, yPos);
  };

  renderBox("Merchant", x);
  renderBox("Penerima", recipientX);

  return y;
};
